function convertToLocalTime(date: string) {
  var dateLocal = new Date(date);
  var newDate = new Date(dateLocal.getTime() - dateLocal.getTimezoneOffset() * 60 * 1000);
  return newDate;
}

export default convertToLocalTime;
//
